// src/constants/supportConstants.js

export const SUPPORT_STATUSES = [
  { value: 'open', label: 'Open', color: 'info', icon: '📩' },
  { value: 'in-progress', label: 'In Progress', color: 'warning', icon: '🔄' },
  { value: 'waiting-for-seller', label: 'Waiting for Seller', color: 'warning', icon: '⏳' },
  { value: 'waiting-for-support', label: 'Waiting for Support', color: 'secondary', icon: '📨' },
  { value: 'resolved', label: 'Resolved', color: 'success', icon: '✅' },
  { value: 'closed', label: 'Closed', color: 'default', icon: '📁' },
];

export const SUPPORT_CATEGORIES = [
  { value: 'general', label: 'General' },
  { value: 'technical', label: 'Technical' },
  { value: 'billing', label: 'Billing' },
  { value: 'account', label: 'Account' },
  { value: 'products', label: 'Products' },
  { value: 'orders', label: 'Orders' },
  { value: 'payments', label: 'Payments' },
  { value: 'shipping', label: 'Shipping' },
  { value: 'returns', label: 'Returns' },
  { value: 'commission', label: 'Commission' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'support', label: 'Support' },
  { value: 'other', label: 'Other' },
];

export const PRIORITY_LEVELS = [
  { value: 'low', label: 'Low', color: 'info' },
  { value: 'medium', label: 'Medium', color: 'warning' },
  { value: 'high', label: 'High', color: 'error' },
  { value: 'urgent', label: 'Urgent', color: 'error' },
];

export const getStatusConfig = (status) => {
  const found = SUPPORT_STATUSES.find(s => s.value === status);
  return found || SUPPORT_STATUSES[0];
};

export const getCategoryLabel = (category) => {
  const found = SUPPORT_CATEGORIES.find(c => c.value === category);
  return found ? found.label : category || 'General';
};

export const getPriorityConfig = (priority) => {
  const found = PRIORITY_LEVELS.find(p => p.value === priority);
  return found || PRIORITY_LEVELS[1];
};

export const getCategoryIcon = (category) => {
  const icons = {
    general: '📌',
    technical: '⚙️',
    billing: '💰',
    account: '👤',
    products: '📦',
    orders: '🛒',
    payments: '💳',
    shipping: '🚚',
    returns: '↩️',
    commission: '🏷️',
    delivery: '📦',
    support: '🆘',
    other: '📎',
  };
  return icons[category] || '📌';
};